import { MantineSize, Modal, ModalBaseProps } from '@mantine/core'

import { ModalForm, ModalFormProps } from './ModalForm'

interface ModalShellProps extends ModalFormProps {
  opened: boolean
  title: string
  size?: MantineSize | number
  centered?: boolean
  modalProps?: Partial<ModalBaseProps>
}

export function ModalShell(props: ModalShellProps) {
  const { size, title, opened, onClose, loading, centered } = props

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={size}
      title={title}
      closeOnEscape={!loading}
      centered={centered}
      {...props.modalProps}
    >
      <ModalForm {...props} />
    </Modal>
  )
}
